"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * This file contains the javascript functions and snippets
 * that are used to introduce the site feedback link in the footer.
 * Function O_GoT inserts the link in the footer list and assigns onclick
 * for popup window that displays the feedback from from opinionlab site.
 *
 *
 * Note: Slight modifications have been made to original code from WalletExpNodeWeb to work in TS, but no functional
 * changes have been made, other than removing the reliance on jQuery to modify element classes:
 * ConsumerWeb-R/walletexpnodeweb/blob/develop/public/js/components/UVLOpinionLab/opinionLab.js
 */
/* eslint-disable */
function setupOpinionLab(opinionLabVars) {
    var _tm = (new Date()).getTime(), _sH = screen.height, _sW = screen.width;
    /**
     * This method forms the siteFeedback image tag to be written into the DOM
     * Note: While calling this method, please make sure to check if sitefbIcon is enabled. This is decided by boolean
     * the property 'showSitefbIcon'.
     * @returns sfimg
     */
    function siteFeedBackImage() {
        var sfImg = document.createElement('img');
        sfImg.setAttribute('src', opinionLabVars.sitefb_plus_icon);
        sfImg.setAttribute('alt', '');
        return sfImg;
    }
    function popUp(opinionlabURL) {
        window.open(opinionlabURL, 'comments', 'width=535,height=192'
            + ',screenX=' + ((_sW - 535) / 2)
            + ',screenY=' + ((_sH - 192) / 2)
            + ',top=' + ((_sH - 192) / 2)
            + ',left=' + ((_sW - 535) / 2)
            + ',resizable=yes'
            + ',copyhistory=yes'
            + ',scrollbars=no');
    }
    function createLink(_p) {
        var sfLink = document.createElement('a');
        sfLink.setAttribute('href', '#');
        sfLink.innerHTML = _p;
        sfLink.className = (opinionLabVars.className || 'feedback');
        var siteFeedback = document.getElementById('siteFeedback');
        if (siteFeedback) {
            siteFeedback.appendChild(sfLink);
            if (opinionLabVars.showSitefbIcon) {
                siteFeedback.appendChild(siteFeedBackImage());
            }
        }
        return sfLink;
    }
    function _fC(_u) {
        var _sp = '%3A\\/\\/', _rp = '%3A//', _aT = _sp + ',\\/,\\.,-,_,' + _rp + ',%2F,%2E,%2D,%5F', _aA = _aT.split(',');
        for (var i = 0; i < 5; i++) {
            eval('_u=_u.replace(/' + _aA[i] + '/g,_aA[i+5])');
        }
        return _u;
    }
    return {
        custom_var: '',
        _ht: encodeURI(window.location.href),
        _hr: document.referrer,
        _kp: 0,
        baseurl: '',
        url_var: '',
        assignSiteCatalystVars: '',
        PP_O_LC: function (openPopup) {
            var opinionlabURL = this.baseurl + '&olparams='
                + 'time1$' + _tm
                + '|time2$' + (new Date()).getTime()
                + '|prev$' + _fC(encodeURI(this._hr))
                + '|referer$' + _fC(this._ht)
                + '|height$' + _sH
                + '|width$' + _sW
                + '&custom_var=' + this.custom_var;
            if (openPopup) {
                popUp(opinionlabURL);
            }
            else {
                return opinionlabURL;
            }
        },
        O_LC: function (openPopup) {
            var opinionlabURL = 'https://secure.opinionlab.com/ccc01/comment_card.asp?'
                + 'time1=' + _tm
                + '&time2=' + (new Date()).getTime()
                + '&prev=' + _fC(encodeURI(this._hr))
                + '&referer=' + _fC(this._ht)
                + '&height=' + _sH
                + '&width=' + _sW
                + '&custom_var=' + this.custom_var
                + (this.url_var !== undefined && this.url_var.length > 0 ? '&url_var=' + _fC(encodeURI(this.url_var)) : '');
            if (openPopup) {
                popUp(opinionlabURL);
            }
            else {
                return opinionlabURL;
            }
        },
        O_GoT: function (_p) {
            var sfLink = createLink(_p), self = this;
            sfLink.onclick = function () {
                self.assignSiteCatalystVars();
                self.O_LC(true);
                return false;
            };
            this.PP_Beta();
        },
        PP_O_GoT: function (_p) {
            var sfLink = createLink(_p), self = this;
            sfLink.onclick = function () {
                self.assignSiteCatalystVars();
                self.PP_O_LC(true);
                return false;
            };
            this.PP_Beta();
        },
        PP_Beta: function () {
            // Override the original handler
            var node = document.getElementById('siteFeedback'), list = node ? node.getElementsByTagName('a') : [], indx = list.length, $beta = document.querySelector('.js_feedbackLink'), self = this;
            while ($beta && indx--) {
                list.item(indx).onclick = null;
            }
            if ($beta) {
                // Style the link and attach the new event handler
                $beta.classList.add('hidden-phone');
                $beta.classList.remove('hidden');
                $beta.addEventListener('click', function (event) {
                    var url;
                    self.assignSiteCatalystVars();
                    url = 'https://secure.opinionlab.com/ccc01/comment_card.asp?' +
                        'custom_var=' + self.custom_var +
                        '&height=' + _sH +
                        '&referer=' + encodeURIComponent('http://beta.paypal.com/' + opinionLabVars.languageCode + '_' +
                        opinionLabVars.countryCode + location.pathname) +
                        '&prev=' + encodeURIComponent(document.referrer) +
                        '&time1=' + _tm +
                        '&time2=' + (new Date()).getTime() +
                        '&width=' + _sW;
                    event.preventDefault();
                    popUp(url);
                });
            }
        },
        Mini_O_GoT: function (_p, base) {
            var sfLink = document.createElement('a'), sfLinkSpan = document.createElement('span'), self = this;
            sfLink.setAttribute('href', '#');
            if (opinionLabVars.showSitefbIcon) {
                sfLink.appendChild(siteFeedBackImage());
            }
            if (base) {
                sfLink.onclick = function () {
                    self.assignSiteCatalystVars();
                    self.PP_O_LC(true);
                    return false;
                };
            }
            else {
                sfLink.onclick = function () {
                    self.assignSiteCatalystVars();
                    self.O_LC(true);
                    return false;
                };
            }
            sfLinkSpan.innerHTML = _p;
            sfLink.appendChild(sfLinkSpan);
            var siteFeedback = document.getElementById('siteFeedback');
            if (siteFeedback) {
                siteFeedback.appendChild(sfLink);
            }
        }
    };
}
exports.default = setupOpinionLab;
;
